<template>
	<div class="card mb-4">
		<div class="card-body">
			<h2 class="card-title">Private Page</h2>
		</div>
	</div>
</template>

<script>
export default {
  name: 'PrivatePage',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
